export default __webpack_public_path__ + "static/media/V_Old_White.3bf12018.png";